import * as go from 'gojs';

const $ = go.GraphObject.make;

const ContextMenu = (
  myDiagram: go.Diagram,
  showcontextMenu: () => void,
  hideContextMenu: () => void,
) => {
  const cxElement = document.getElementById('contextMenu');
  if (!cxElement) return null;

  const myContextMenu = $(go.HTMLInfo, {
    show: () => {
      showcontextMenu();
    },
    hide: () => {
      hideContextMenu();
    },
  });
  return myContextMenu;
};

export default ContextMenu;
